var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vf-logo",class:[
    { 'vf-logo-selected' : _vm.selected }
],on:{"click":function($event){$event.stopPropagation();return _vm.handleClick($event)}}},[_c('img',{attrs:{"src":_vm.logoUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }